import type { ReactNode } from 'react';

import './DangerZoneWrapper.scss';

interface DangerZoneWrapperProps {
  children: ReactNode;
}

export function DangerZoneWrapper({ children }: DangerZoneWrapperProps) {
  return <div className="Dangerzone">{children}</div>;
}
